// extracted by mini-css-extract-plugin
export default {"submit":"trabalhos_submit__LCOmX","regulamento":"trabalhos_regulamento__UxMdu"};